import styled from 'styled-components';
import { HoveredContainer } from '@rsos/components/capstone/HoveredButton/HoveredButton.styles';
import { Box, Text } from '@rsos/components/capstone/base';

export const CopyRowBox = styled(Box).attrs({
  py: 0,
  px: 0,
  horizontal: true,
  grow: 0,
  align: 'center',
  justify: 'flex-start',
})``;

export const CopyColumnBox = styled(Box).attrs(({ br }) => ({
  py: 0,
  px: 0,
  justify: 'center',
  borderRadius: br || '0',
}))``;

export const RowBox = styled(Box).attrs(
  ({ align, copied, br, isHoverable, noBg }) => ({
    position: 'relative',
    horizontal: true,
    justify: isHoverable || noBg ? 'space-between' : 'flex-start',
    align: align ? align : 'center',
    bg: copied ? 'highlights' : 'inherit',
    borderRadius: br || '0',
    overflow: 'hidden',
  }),
)`
  display: flex; //ellipsis overwrite this
  flex-direction: ${props => props.column && 'column'};
  &:hover ${HoveredContainer} {
    display:${props => (props.isHoverable && !props.noBg ? 'flex' : 'none')};
  }
  &:hover {
    cursor: ${props => (props.isHoverable && !props.noBg ? 'auto' : 'inherit')};
    background: ${props =>
      props.copied
        ? props.theme.colors.highlights
        : props.isHoverable && !props.noBg
          ? props.theme.colors.foreground
          : 'inherit'};
`;

export const LocationAddressContainer = styled(Box).attrs(({ br }) => ({
  horizontal: false,
  position: 'relative',
  bg: 'inherit',
  justify: 'center',
  borderRadius: br || '0',
}))``;

export const LeftText = styled(Text).attrs(({ secondary }) => ({
  size: secondary ? 'xsmall' : 'normal',
  color: 'secondaryText',
}))``;

export const MiddleText = styled(Text).attrs(({ secondary }) => ({
  size: secondary ? 'xsmall' : 'normal',
  color: 'primaryText',
}))`
  flex-grow: 1;
  white-space: ${props => (props.wrap ? 'pre-wrap' : 'nowrap')};
`;

export const ButtonText = styled(Text).attrs({
  pl: 2,
})``;

export const LoaderContainer = styled(Box).attrs({
  height: '31px',
  width: '100%',
})`
  & > div {
    height: 28px;
    padding-top: 13px;
    & > div {
      height: 20px;
    }
  }
`;

export const SecondaryText = styled(Text).attrs({
  color: 'secondaryText',
  size: 'xsmall',
})``;

export const ExtraData = styled(SecondaryText)``;

export const EstimatedAddress = styled(SecondaryText)``;

export const ExtraDataContainer = styled(Box).attrs(({ isCompact }) => ({
  horizontal: true,
  flexWrap: 'wrap',
  align: 'center',
  marginBottom: isCompact ? '0' : '10px',
}))`
  div:nth-child(n + 2):not(:last-child) {
    padding-left: 2px;
  }
`;

export const IconWrapper = styled(Box).attrs({
  marginRight: '8px',
  color: 'secondaryText',
})``;
